import { render, staticRenderFns } from "./SheletonLoaders.vue?vue&type=template&id=00498fac&scoped=true"
var script = {}
import style0 from "./SheletonLoaders.vue?vue&type=style&index=0&id=00498fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00498fac",
  null
  
)

export default component.exports